export const estimateExtendedWorkflowIds = [
	//
	// requestType = estimate
	//

	'sealingPrePricing',
	'pricing',
	'estimateManagement',
	'sealingPostEstimateManagement',
	'estimateAcceptance',
] as const;

export const orderExtendedWorkflowIds = [
	//
	// requestType = order
	//

	'accountingReviewPreDesign',
	'invoicingPreScheduleDelivery',
	'scheduleDelivery',
	//
	'optimizationPreSealing',
	'sealingPreOrderManagement',
	'checkPriceBeforeOrderManagement',
	'orderManagement',
	'sealingPostOrderManagement',
	'optimizationPostSealing',
	'priceCheck',
	'accountingReviewPreProduction',
	'batching',
	'production',
	'staging',
	'invoicingPreDelivery',
	'delivery',
	'invoicingPostDelivery',
	'managementReview',
] as const;

export const extendedWorkflowIds = [
	'fileProcessing',

	//
	// requestType = estimate
	//

	...estimateExtendedWorkflowIds,

	//
	// requestType = order
	//

	...orderExtendedWorkflowIds,
] as const;

export const aiStageIds = [
	'preprocess',
	'fps',
	'jrf',
	'hitl',
	'trussHitl',
	'frame',
	'wholeHouse',
] as const;

export const ids = [
	//
	// common stages
	//

	'draft',
	//
	...aiStageIds,
	//
	'design',
	'designSimple',
	//
	...extendedWorkflowIds,
] as const;
